import { render, staticRenderFns } from "./ZuJian_WaiJiaJi_XiaoSuanYin.vue?vue&type=template&id=0fd0a948&"
import script from "./ZuJian_WaiJiaJi_XiaoSuanYin.vue?vue&type=script&lang=js&"
export * from "./ZuJian_WaiJiaJi_XiaoSuanYin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports